import React from 'react';
import './ConfirmModal.css';

export const incompleteRepairServices = (services = []) => services.flatMap(service => {
  if (/^other[-\s]/i.test(String(service.name || ''))) return [];
  const tasks = service.tasks?.length ? service.tasks : service.taskProgress;
  return (tasks?.length ? tasks : [{ status: service.serviceStatus || service.status || 'Pending' }])
    .filter(task => String(task.status || 'Pending').toLowerCase() !== 'completed')
    .map(task => ({
      name: [service.name || 'Repair', service.description, task.subService, task.groupName].filter(Boolean).join(' — '),
      status: task.status || 'Pending',
    }));
});

export default function RepairCloseConfirm({ services, onConfirm, onCancel }) {
  return <div className="confirm-modal-overlay">
    <div className="confirm-modal" role="dialog" aria-modal="true" aria-labelledby="repair-close-title">
      <p id="repair-close-title">Following Services are not marked Completed, please check.</p>
      <ul style={{ textAlign: 'left', maxHeight: '40vh', overflowY: 'auto' }}>
        {services.map((service, index) => <li key={index}>{service.name}: <strong>{service.status}</strong></li>)}
      </ul>
      <p>Do you want to Close the Repair Order and mark all repairs Completed?</p>
      <div className="confirm-buttons">
        <button type="button" className="button blue" onClick={onConfirm}>Yes</button>
        <button type="button" className="button red" onClick={onCancel} autoFocus>Cancel</button>
      </div>
    </div>
  </div>;
}
